import React from 'react';
import {useSelector} from 'react-redux';
import SimpleBar from 'simplebar-react';
import SidebarContent from './SidebarContent';

const Sidebar = () => {
  const {type} = useSelector((state) => state.Layout);

  return (
    <div className="vertical-menu">
      <div data-simplebar className="h-100">
        {type !== 'condensed' ? (
          <SimpleBar style={{maxHeight: '100%'}}>
            <SidebarContent />
          </SimpleBar>
        ) : (
          <SidebarContent />
        )}
      </div>
    </div>
  );
};

export default Sidebar;
